import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyChangingEmail } from '@api/auth';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      navigate('/activation-code-expired');
      return;
    }

    const verifyEmail = async () => {
      try {
        const res = await verifyChangingEmail(token);
        if (res?.status === 'success') {
          localStorage.removeItem('authToken');
          navigate('/email-changed-success');
        }
      } catch (error) {
        navigate('/activation-code-expired');
      }
    };

    verifyEmail();
  }, [navigate, searchParams]);

  return (
    <div className="govuk-width-container mt-10">
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-three-quarters">
          <h1 className="govuk-heading-xl">Confirming New Email Address...</h1>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
